import { ProductType } from '@/types'
import Axios from 'axios'

import { SEARCH_API } from './Configuration'

import { ClientSideCache } from './Helpers'
import { log } from './Log'

const CacheBySku = ClientSideCache(({ sku }) => sku)
const CacheBySkus = ClientSideCache((skus) => skus)

type SearchAPISkusFetcher = (skus: string[]) => Promise<Array<ProductType>>
const getProductBySkus: SearchAPISkusFetcher = CacheBySkus(async (skus: string[]) => (
  (await Axios.get<Array<ProductType>>(`${SEARCH_API}/product`, { params: { skus: skus.join(',') } })).data
))

type SearchAPISkuFetcher = (input: { sku: string }) => Promise<ProductType | null>
const getProductBySku: SearchAPISkuFetcher = CacheBySku(async ({ sku }) => {
  log(`Product.bySku sku: ${sku}`, { sku })
  return (await getProductBySkus([sku]))?.[0] || null
})

const Product = {
  bySkus: getProductBySkus,
  bySku: getProductBySku,
}

export default Product
